import {config} from '@/config';

/**
 * Estado de la convocatoria de vendors: abierta o cerrada. Única fuente de
 * verdad — el formulario, el rótulo de la sección y los CTAs leen de aquí.
 *
 * El cierre es automático al pasar config.REGISTRATION_DEADLINE, así que nadie
 * tiene que acordarse de desplegar un cambio el día del cierre.
 *
 * ## Cómo probarlo (funciona igual en local y en producción)
 *
 *   ?cierre=1            → fuerza el estado cerrado
 *   ?cierre=0            → fuerza el estado abierto
 *   ?hoy=2026-09-30      → simula esa fecha y deja que la lógica real decida
 *
 * El par que prueba el borde: ?hoy=2026-09-29 sigue abierto (el último día
 * cuenta completo) y ?hoy=2026-09-30 sale cerrado.
 *
 * Los parámetros solo cambian lo que se muestra en pantalla, por eso es seguro
 * dejarlos activos en producción: sirven para enseñarle al cliente cómo
 * quedará el sitio sin esperar a la fecha.
 */

/** Se leen una sola vez: no cambian durante la sesión. */
const params = new URLSearchParams(window.location.search);

/** Fecha simulada por ?hoy=. Se ancla al mediodía de PR para que un
 *  "2026-09-30" no quede a un lado u otro del corte por la zona horaria. */
function simulatedDate(): Date | null {
  const raw = params.get('hoy');
  if (!raw || !/^\d{4}-\d{2}-\d{2}$/.test(raw)) return null;
  const date = new Date(`${raw}T12:00:00-04:00`);
  // Un enlace mal copiado no debe dejar el sitio en un estado raro.
  return Number.isNaN(date.getTime()) ? null : date;
}

function computeIsOpen(): boolean {
  const forced = params.get('cierre');
  if (forced === '1') return false;
  if (forced === '0') return true;

  // Interruptor de emergencia: cierra ya, sin importar la fecha.
  if (!config.REGISTRATION_OPEN) return false;

  const now = simulatedDate() ?? new Date();
  return now.getTime() <= new Date(config.REGISTRATION_DEADLINE).getTime();
}

const open = computeIsOpen();

export function isRegistrationOpen(): boolean {
  return open;
}

/** Copia que depende del estado, junta en un solo sitio. */
export const CTA_LABEL = open ? 'Quiero ser un comercio participante' : 'Info para comercio participante';
export const EYEBROW_LABEL = open ? 'Convocatoria abierta' : 'Convocatoria cerrada';
export const FORM_TITLE = open ? 'Regístrate como comercio participante' : 'Convocatoria de comercios participantes';
